import Styles from './CreateMetric.module.scss';
import { useState, useContext, Fragment, useEffect } from 'react';

import { useNavigate, ViewContext, useAPI, useParams, Message, useTranslation } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';

import * as FeatherIconsList from 'feather-icons-react';
import FeatherIcon from 'feather-icons-react';
import {
    TextField, Slider, MenuItem, Tooltip, Checkbox, FormControlLabel,
    Dialog, DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import axios from 'axios';

const BucketsEditor = ({ rangeBuckets, onChangeBuckets, setShowBucketEditor }) => {

    const { t } = useTranslation();
    const [tempRangeBuckets, setTempRangeBuckets] = useState(rangeBuckets)

    const onRangeBucketChange = (bucket, field, value) => {
        setTempRangeBuckets((prevDetails) => ({
            ...prevDetails,
            [bucket]: {
                ...prevDetails[bucket], // Keep other fields in the bucket intact
                [field]: value // Update the specific field (title or bucketText)
            }
        }))
    }

    return (
        <>
            <Dialog
                open={true}
                PaperProps={{
                    component: 'form',
                    sx: {
                        width: "75vw",
                        maxWidth: "none"
                    }
                }}
            >
                <DialogContent>
                    <DialogContentText>
                        {t('QualityQuotient.CreateMetric.rangeBucketsEditor.title')}
                    </DialogContentText>
                    <div id='bucketEditor' className={Styles.bucketEditor}>
                        <span className={Styles.bucketEditSpan}>
                            <TextField
                                size="small"
                                id={`fail-title`}
                                name="fail-title"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 50
                                }}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.fail.name")}
                                value={tempRangeBuckets.fail.title}
                                onChange={(e) => onRangeBucketChange("fail", "title", e.target.value)}
                            />
                            <TextField
                                size="small"
                                id={`fail-text`}
                                name="fail-text"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 120
                                }}
                                multiline
                                rows={2}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.fail.text")}
                                value={tempRangeBuckets.fail.bucketText}
                                onChange={(e) => onRangeBucketChange("fail", "bucketText", e.target.value)}
                            />
                        </span>
                        <span className={Styles.bucketEditSpan}>
                            <TextField
                                size="small"
                                id={`average-title`}
                                name="average-title"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 50
                                }}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.average.name")}
                                value={tempRangeBuckets.average.title}
                                onChange={(e) => onRangeBucketChange("average", "title", e.target.value)}
                            />
                            <TextField
                                size="small"
                                id={`average-text`}
                                name="average-text"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 120
                                }}
                                multiline
                                rows={2}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.average.text")}
                                value={tempRangeBuckets.average.bucketText}
                                onChange={(e) => onRangeBucketChange("average", "bucketText", e.target.value)}
                            />
                        </span>

                        <span className={Styles.bucketEditSpan}>
                            <TextField
                                size="small"
                                id={`good-title`}
                                name="good-title"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 50
                                }}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.good.name")}
                                value={tempRangeBuckets.good.title}
                                onChange={(e) => onRangeBucketChange("good", "title", e.target.value)}
                            />
                            <TextField
                                size="small"
                                id={`good-text`}
                                name="good-text"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 120
                                }}
                                multiline
                                rows={2}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.good.text")}
                                value={tempRangeBuckets.good.bucketText}
                                onChange={(e) => onRangeBucketChange("good", "bucketText", e.target.value)}
                            />
                        </span>

                        <span className={Styles.bucketEditSpan}>
                            <TextField
                                size="small"
                                id={`exceptional-title`}
                                name="exceptional-title"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 50
                                }}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.exceptional.name")}
                                value={tempRangeBuckets.exceptional.title}
                                onChange={(e) => onRangeBucketChange("exceptional", "title", e.target.value)}
                            />
                            <TextField
                                size="small"
                                id={`exceptional-text`}
                                name="exceptional-text"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 120
                                }}
                                multiline
                                rows={2}
                                label={t("QualityQuotient.CreateMetric.rangeBucketsEditor.exceptional.text")}
                                value={tempRangeBuckets.exceptional.bucketText}
                                onChange={(e) => onRangeBucketChange("exceptional", "bucketText", e.target.value)}
                            />
                        </span>
                    </div>
                </DialogContent>
                <DialogActions>
                    <AivagamButton
                        type="cancel"
                        buttonText={t("QualityQuotient.CreateMetric.rangeBucketsEditor.button.discard")}
                        onClick={() => {
                            setShowBucketEditor(false)
                        }}
                    />
                    <AivagamButton
                        buttonText={t("QualityQuotient.CreateMetric.rangeBucketsEditor.button.keep")}
                        onClick={() => {
                            onChangeBuckets('rangeBuckets', tempRangeBuckets)
                            setShowBucketEditor(false)
                        }}
                    />
                </DialogActions>
            </Dialog>
        </>
    )
}

export function CreateMetric(props) {

    const { t } = useTranslation();
    const [metricDetails, setMetricDetails] = useState({
        name: "",
        range: [30, 50, 80],
        rangeBuckets: {
            fail: {
                title: "Fail",
                bucketText: "There are significant areas where you can improve!"
            },
            average: {
                title: "Average",
                bucketText: "There are areas where you can improve!"
            },
            good: {
                title: "Good",
                bucketText: "You excel in some areas but can be better!"
            },
            exceptional: {
                title: "Exceptional",
                bucketText: "You excel in all areas!"
            }
        },
        icon: "",
        is_random: false,
        max_attempts: null
    })
    const [assessmentData, setAssessmentData] = useState([])
    const [showAddAssess, setShowAddAssess] = useState(false);
    const [editAssessment, setEditAssessment] = useState(-1);
    const [editingOrder, setEditingOrder] = useState(false);
    const [deleteAssessment, setDeleteAssessment] = useState(false);
    const [showBucketEditor, setShowBucketEditor] = useState(false);
    const [showUpdateTooltip, setShowUpdateTooltip] = useState(false);

    const { id: metricID } = useParams();
    const { action: pageAction } = useParams();
    const isCreateAction = pageAction === "create";

    const { data, loading } = useAPI(isCreateAction ? "" : `/api/metrics/${metricID}`)

    useEffect(() => {
        if (data) {
            setMetricDetails({
                ...data?.info
            })
            setAssessmentData(data.assessment)
            if (isCreateAction) {
                document.title = t("QualityQuotient.CreateMetric.title.create")
            } else {
                document.title = `${t("QualityQuotient.CreateMetric.title.edit")} ${data?.info?.name}`
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const viewContext = useContext(ViewContext);
    const navigate = useNavigate();

    const handleChange = (name, value) => {
        if (name === "max_attempts" && value < 1 && value !== "") {
            return;
        }
        setMetricDetails(prevState => ({
            ...prevState,
            [name]: value,
        }));
        setShowUpdateTooltip(true)
    };

    const minDistance = 10;
    const handleSliderChange = (event, value, activeThumb) => {
        if (!Array.isArray(value)) {
            return;
        }

        let newRange = [...metricDetails.range];

        if (activeThumb === 0) {
            newRange = [
                Math.min(value[0], newRange[1] - minDistance),
                newRange[1],
                newRange[2]
            ];
        } else if (activeThumb === 1) {
            newRange = [
                newRange[0],
                Math.max(Math.min(value[1], newRange[2] - minDistance), newRange[0] + minDistance),
                newRange[2]
            ];
        } else {
            newRange = [
                newRange[0],
                newRange[1],
                Math.max(value[2], newRange[1] + minDistance)
            ];
        }

        handleChange(event.target.name, newRange);
    };

    const FeatherIconsNameArray = Object.keys(FeatherIconsList)

    const saveChangedOrder = () => {
        const assessmentArray = assessmentData.map((assessment) => assessment.id)
        const options = {
            method: "PATCH",
            url: `/api/metrics/${metricID}`,
            headers: {
                "accept": "application/json",
            },
            data: { assessmentArray: assessmentArray },
        };
        axios
            .request(options)
            .then(function (response) {
                setEditingOrder(false)
                viewContext.notification.show(response.data.message, "success")
            })
            .catch((err) => {
                viewContext.handleError(err);
            });

    }

    const handleAssessDelete = (entry) => {
        const assessmentArray = assessmentData.map((assessment) => assessment.id)
        assessmentArray.splice(entry, 1)

        const options = {
            method: "DELETE",
            url: `/api/assessment/${assessmentData[entry].id}`,
            headers: {
                "accept": "application/json",
            },
            data: { assessmentArray: assessmentArray, metricID: metricID },
        };
        axios
            .request(options)
            .then(function (response) {
                viewContext.notification.show(t('QualityQuotient.CreateMetric.notification.assessDelete'), "success")
                window.location.reload()
            })
            .catch((err) => {
                viewContext.handleError(err);
            });
    }

    const disableAssessmentEdit = ["closed", "published"].includes(metricDetails?.status)

    const AssessmentCard = ({ assessmentDataEntry, currentIndex }) => {

        const changeOrder = (currentIndex, newIndex) => {
            if (metricDetails.status !== "published") {
                if (newIndex !== -1 && newIndex !== assessmentData.length) {
                    setEditingOrder(true)
                    const tempAssessmentData = [...assessmentData];

                    const [movedItem] = tempAssessmentData.splice(currentIndex, 1);

                    tempAssessmentData.splice(newIndex, 0, movedItem);

                    setAssessmentData(tempAssessmentData);
                } else {
                    viewContext.notification.show(t('QualityQuotient.CreateMetric.notification.assessmentCard'), "warning", true)
                }
            } else {
                viewContext.notification.show(t('QualityQuotient.CreateMetric.notification.assesOrder'), "warning", true)
            }
        }

        return (
            <>
                <div key={assessmentDataEntry.id} id='assessmentCard' className={Styles.assessmentCard}>
                    <span>
                        {currentIndex + 1}
                    </span>
                    <span id='orderControls' className={Styles.orderControls}>
                        <FeatherIcon
                            size="0.9em"
                            icon="chevron-up"
                            onClick={() => { changeOrder(currentIndex, currentIndex - 1) }}
                        />
                        <FeatherIcon
                            size="0.9em"
                            icon="chevron-down"
                            onClick={() => { changeOrder(currentIndex, currentIndex + 1) }}
                        />
                    </span>

                    <span id='interactionsContainer' className={Styles.interactionsContainer}>
                        {assessmentDataEntry.name}
                        <span>
                            {
                                !assessmentDataEntry?.questions &&
                                <span id="warningText" className={Styles.warningText}>
                                    {t('QualityQuotient.CreateMetric.assessmentCard.missingQuestion')}
                                </span>
                            }
                            <Tooltip title={t('QualityQuotient.CreateMetric.assessmentCard.tooltip.delete')}>
                                <span>
                                    <button
                                        className={Styles.iconButton}
                                    >
                                        <FeatherIcon
                                            color='black'
                                            icon='trash'
                                            onClick={() => {
                                                if (disableAssessmentEdit) {
                                                    viewContext.notification.show(t('QualityQuotient.CreateMetric.notification.assesNoDelete'),
                                                        "info",
                                                        false)
                                                } else {
                                                    setDeleteAssessment({ show: true, entry: currentIndex })
                                                }
                                            }}
                                        />
                                    </button>
                                </span>
                            </Tooltip>
                            <Tooltip title={t('QualityQuotient.CreateMetric.assessmentCard.tooltip.edit')}>
                                <span>
                                    <button
                                        className={Styles.iconButton}
                                    >
                                        <FeatherIcon
                                            color='black'
                                            icon='edit-2'
                                            onClick={() => {
                                                setShowAddAssess(false)
                                                setEditAssessment(currentIndex)
                                            }}
                                        />
                                    </button>
                                </span>
                            </Tooltip>
                            <Tooltip title={t('QualityQuotient.CreateMetric.assessmentCard.tooltip.view')}>
                                <button
                                    className={Styles.iconButton}
                                >
                                    <span>
                                        <FeatherIcon
                                            color='black'
                                            icon='chevron-right'
                                            onClick={() => {
                                                navigate(`/metrics/${metricID}/assessment/${assessmentDataEntry.id}`)
                                            }}
                                        />
                                    </span>
                                </button>
                            </Tooltip>
                        </span>
                    </span>
                </div>
            </>

        )
    }

    const AddAssessmentJSX = ({ currentIndex }) => {

        const [assessTitle, setAssessTitle] = useState("")

        useEffect(() => {
            if (editAssessment >= 0) {
                setAssessTitle(assessmentData[editAssessment].name)
            }
        }, [])

        const addAssessment = () => {
            if (editAssessment >= 0) {
                const options = {
                    method: "PATCH",
                    url: `/api/assessment/${assessmentData[editAssessment].id}`,
                    headers: {
                        "accept": "application/json",
                    },
                    data: { name: assessTitle },
                };
                axios
                    .request(options)
                    .then(function (response) {
                        const tempAssessmentData = [...assessmentData];
                        tempAssessmentData[currentIndex].name = assessTitle
                        setAssessmentData(tempAssessmentData)
                        setEditAssessment(-1)
                        viewContext.notification.show(response.data.message, "success")
                    })
                    .catch((err) => {
                        viewContext.handleError(err);
                    });
            } else {
                const assessmentArray = assessmentData.map((assessment) => assessment.id)
                const options = {
                    method: "POST",
                    url: `/api/metrics/${metricID}/assessment`,
                    headers: {
                        "accept": "application/json",
                    },
                    data: { name: assessTitle, assessmentArray: assessmentArray },
                };
                axios
                    .request(options)
                    .then(function (response) {
                        setAssessmentData(prev => ([
                            ...prev,
                            {
                                // id to be filled from api call
                                id: response.data.assessmentID,
                                name: assessTitle,
                                questions: null
                            }
                        ]))
                        viewContext.notification.show(response.data.message, "success")
                    })
                    .catch((err) => {
                        viewContext.handleError(err);
                    });
            }
            setShowAddAssess(false)
        }

        return (
            <div key={assessmentData.id} id='assessmentCard' className={Styles.assessmentCard}>
                <span>
                    {currentIndex + 1}
                </span>
                <span id='orderControls' className={Styles.orderControls}>
                    <FeatherIcon
                        size="0.9em"
                        icon="chevron-up"
                        disabled={true}
                        color="lightgrey"
                    />
                    <FeatherIcon
                        size="0.9em"
                        icon="chevron-down"
                        disabled={true}
                        color="lightgrey"
                    />
                </span>
                <span id='interactionsContainer' className={Styles.interactionsContainer}>
                    <TextField
                        size="small"
                        placeholder={t('QualityQuotient.CreateMetric.AddAssessmentJSX.assessName')}
                        id={`assessment-name`}
                        name="name"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            maxLength: 50
                        }}
                        value={assessTitle || ""}
                        onChange={(e) => setAssessTitle(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                addAssessment()
                            } else if (e.key === 'Escape') {
                                setShowAddAssess(false)
                                if (editAssessment >= 0) {
                                    setEditAssessment(-1)
                                }
                            }
                        }}
                    />
                    <span>
                        <Tooltip arrow title={t('QualityQuotient.CreateMetric.AddAssessmentJSX.button.discard')}>
                            <span>
                                <button
                                    onClick={() => {
                                        setShowAddAssess(false)
                                        setEditAssessment(-1)
                                    }}
                                >
                                    <FeatherIcon
                                        color='black'
                                        icon='x'
                                        role="button"
                                    />
                                </button>
                            </span>
                        </Tooltip>
                        <Tooltip arrow title={t('QualityQuotient.CreateMetric.AddAssessmentJSX.button.confirm')}>
                            <span>
                                <button
                                    onClick={() => {
                                        if (assessTitle?.length !== 0 && !assessTitle.startsWith(" "))
                                            addAssessment()
                                    }}
                                >
                                    <FeatherIcon
                                        color='black'
                                        icon='check'
                                        role="button"
                                    />
                                </button>
                            </span>
                        </Tooltip>
                    </span>
                </span>
            </div>
        )
    }

    const postMetricDetails = ({ updateStatus = null }) => {
        let apiMethod;
        let apiURL;

        if (isCreateAction) {
            apiMethod = "POST"
            apiURL = "/api/metrics"
        } else {
            apiMethod = "PATCH"
            apiURL = `/api/metrics/${metricID}`
        }

        let payloadData = {
            ...metricDetails,
            max_attempts: metricDetails.max_attempts === "" ? null : metricDetails.max_attempts
        }

        if (updateStatus) {
            payloadData.status = updateStatus;
        }


        const options = {
            method: apiMethod,
            url: apiURL,
            headers: {
                "accept": "application/json",
            },
            data: payloadData,
        };
        axios
            .request(options)
            .then(function (response) {
                if (isCreateAction) {
                    viewContext.notification.show(t('QualityQuotient.CreateMetric.notification.createMetric'), "success")
                    setTimeout(() => {
                        navigate(`/metrics/${response.data.metricID}/edit`)
                        window.location.reload()
                    }, [500])
                } else {
                    viewContext.notification.show(t('QualityQuotient.CreateMetric.notification.updateMetric'), "success")
                    if (updateStatus) {
                        handleChange("status", updateStatus)
                    }
                }
                setShowUpdateTooltip(false)
            })
            .catch((err) => {
                viewContext.handleError(err);
            });
    }

    function getPublishTooltipText(metricDetails, assessmentData) {
        if (assessmentData.length === 0) {
            return t('QualityQuotient.CreateMetric.form.button.publish.tooltip.addAssessments');
        }

        if (assessmentData.some(assessment => assessment.questions === null)) {
            return t('QualityQuotient.CreateMetric.form.button.publish.tooltip.addQuest');
        }

        return metricDetails.status === "published"
            ? t('QualityQuotient.CreateMetric.form.button.publish.tooltip.published')
            : t('QualityQuotient.CreateMetric.form.button.publish.tooltip.notPublished');
    }


    return (
        <>
            {loading && <LoadingBackdrop isOpen={true} />}
            {deleteAssessment?.show &&
                <ConfirmationCard
                    title={t('QualityQuotient.CreateMetric.deleteConfirm.title')}
                    body={t('QualityQuotient.CreateMetric.deleteConfirm.body')}
                    showCard={deleteAssessment?.show ? true : false}
                    setShowCard={setDeleteAssessment}
                    handleConfirm={() => { handleAssessDelete(deleteAssessment?.entry) }}
                    destructive={true}
                />
            }
            {showBucketEditor &&
                <BucketsEditor
                    rangeBuckets={metricDetails.rangeBuckets}
                    onChangeBuckets={handleChange}
                    setShowBucketEditor={setShowBucketEditor}
                />
            }
            <div id='navButtonsContainer' className={Styles.navButtonsContainer}>
                <AivagamButton
                    id='backButton'
                    onClick={() => {
                        navigate('/user/metrics')
                    }}
                    icon
                    buttonText={
                        <>
                            <FeatherIcon size="0.9em" icon="arrow-left" />
                            {t('QualityQuotient.CreateMetric.backButton')}
                        </>
                    }
                    type="back"
                />
                {!isCreateAction &&
                    <AivagamButton
                        id='fwButton'
                        onClick={() => {
                            navigate('/metrics/create')
                            window.location.reload()
                        }}
                        icon
                        buttonText={
                            <>
                                {t('QualityQuotient.CreateMetric.createNewBtn')}
                                <FeatherIcon size="0.9em" icon="arrow-right" />
                            </>
                        }
                        type="back"
                    />
                }
            </div>
            <div id='oldestDiv' className={Styles.oldestDiv}>
                <div id='ancestorContainer' className={Styles.ancestorContainer}>
                    {/* Metric Form */}
                    {metricDetails?.status?.length &&
                        <Message
                            type="info"
                            title={`${t('QualityQuotient.CreateMetric.message.title')} ${metricDetails?.status?.toUpperCase()}`}
                            text={t('QualityQuotient.CreateMetric.message.text')}
                            closable={false}
                        />
                    }
                    <div id='formHolder' className={Styles.formHolder}>
                        <p id='formTitle' className={Styles.formTitle}>
                            {isCreateAction
                                ? t('QualityQuotient.CreateMetric.formTitle.create')
                                : t('QualityQuotient.CreateMetric.formTitle.edit')
                            }
                        </p>
                        <p id='inputLabel' className={Styles.inputLabel}>
                            {t('QualityQuotient.CreateMetric.label')}
                        </p>
                        <TextField
                            id={`metric-name`}
                            name="name"
                            fullWidth
                            placeholder={t('QualityQuotient.CreateMetric.placeholder')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                maxLength: 100
                            }}
                            value={metricDetails.name || ""}
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                        />
                        <div id='rangeContainer' className={Styles.rangeContainer}>
                            <Tooltip arrow placement="right" title={t('QualityQuotient.CreateMetric.range.tooltip')}>
                                <p id='inputLabel' className={Styles.inputLabel}>
                                    {t('QualityQuotient.CreateMetric.range.label')}
                                    <FeatherIcon size="0.9em" icon="info" />
                                </p>
                            </Tooltip>
                            <Slider
                                sx={{
                                    width: "60%",
                                    marginTop: "1em",
                                    display: "flex",
                                    alignSelf: "center",
                                    '& .MuiSlider-thumb': {
                                        backgroundColor: 'red'
                                    },
                                    '& .MuiSlider-thumb + .MuiSlider-thumb': {
                                        backgroundColor: 'orange',
                                    },
                                    '& .MuiSlider-thumb + .MuiSlider-thumb + .MuiSlider-thumb': {
                                        backgroundColor: "darkgreen"
                                    },

                                }}
                                marks={[
                                    { value: 0, label: 0 },
                                    { value: 100, label: 100 }
                                ]}
                                name="range"
                                track={false}
                                min={5}
                                max={95}
                                step={5}
                                value={metricDetails.range}
                                valueLabelDisplay="auto"
                                onChange={handleSliderChange}
                                disableSwap
                            />
                            <div id='rangeDetails' className={Styles.rangeDetails}>
                                <Tooltip
                                    arrow
                                    title={`${metricDetails?.rangeBuckets?.fail.title.toUpperCase()}: ${metricDetails?.rangeBuckets?.fail.bucketText}`}
                                >
                                    <span className={Styles.rangeDetailsSub}>
                                        <span className={Styles.rangeTitle} style={{ textDecoration: "underline red" }}>
                                            {metricDetails?.rangeBuckets?.fail.title.toUpperCase()}
                                        </span>
                                        <span>0 to {metricDetails.range[0]}</span>
                                    </span>
                                </Tooltip>
                                <Tooltip
                                    arrow
                                    title={`${metricDetails?.rangeBuckets?.average.title.toUpperCase()}: ${metricDetails?.rangeBuckets?.average.bucketText}`}
                                >
                                    <span className={Styles.rangeDetailsSub}>
                                        <span className={Styles.rangeTitle} style={{ textDecoration: "underline orange" }}>
                                            {metricDetails?.rangeBuckets?.average.title.toUpperCase()}
                                        </span>
                                        <span>{metricDetails.range[0]} to {metricDetails.range[1]}</span>
                                    </span>
                                </Tooltip>
                                <Tooltip
                                    arrow
                                    title={`${metricDetails?.rangeBuckets?.good.title.toUpperCase()}: ${metricDetails?.rangeBuckets?.good.bucketText}`}
                                >
                                    <span className={Styles.rangeDetailsSub}>
                                        <span className={Styles.rangeTitle} style={{ textDecoration: "underline yellow" }}>
                                            {metricDetails?.rangeBuckets?.good.title.toUpperCase()}
                                        </span>
                                        <span>{metricDetails.range[1]} to {metricDetails.range[2]}</span>
                                    </span>
                                </Tooltip>
                                <Tooltip
                                    arrow
                                    title={`${metricDetails?.rangeBuckets?.exceptional.title.toUpperCase()}: ${metricDetails?.rangeBuckets?.exceptional.bucketText}`}
                                >
                                    <span className={Styles.rangeDetailsSub}>
                                        <span className={Styles.rangeTitle} style={{ textDecoration: "underline blue" }}>
                                            {metricDetails?.rangeBuckets?.exceptional.title.toUpperCase()}
                                        </span>
                                        <span>{metricDetails.range[2]} to 100</span>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow title={t('QualityQuotient.CreateMetric.range.editTooltip')}>
                                    <span>
                                        <button
                                            id='toposIconButton'
                                            className={Styles.editBucketBtn}
                                            aria-label='Edit Buckets Button'
                                            onClick={() => setShowBucketEditor(true)}
                                        >
                                            <FeatherIcon size="1.1em" icon="edit-2" />
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <Tooltip arrow placement="right" title={t('QualityQuotient.CreateMetric.selectIcon.tooltip')}>
                            <p
                                id='inputLabel'
                                className={Styles.inputLabel}
                                // onClick={() => window.open("https://feathericons.com/", '_blank')}
                                style={{
                                    cursor: "pointer"
                                }}
                            >
                                {t('QualityQuotient.CreateMetric.selectIcon.iconLink')} <FeatherIcon size="0.9em" icon="info" />
                            </p>
                        </Tooltip>
                        <TextField
                            id={`module-icon`}
                            name="icon"
                            fullWidth
                            select
                            required
                            placeholder={t('QualityQuotient.CreateMetric.selectIcon.placeHolder')}
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                                select: {
                                    displayEmpty: true,
                                    defaultValue: true,
                                    renderValue: (selected) => {
                                        if (!selected) {
                                            return <em>{t('QualityQuotient.CreateMetric.selectIcon.default')}</em>;
                                        }
                                        const IconComponent = FeatherIconsList[selected]
                                        return (
                                            <div style={{ display: "flex", gap: "0.2em", alignItems: "center" }}>
                                                <IconComponent size="1.5em" />
                                            </div>
                                        );
                                    },
                                    MenuProps: {
                                        PaperProps: {
                                            style: {
                                                maxHeight: 400, // Adjust as needed
                                            },
                                        },
                                        MenuListProps: {
                                            style: {
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(50px, 1fr))',
                                                gap: '0.5em',
                                                padding: '0.5em',
                                            },
                                        },
                                    },
                                }
                            }}
                            value={metricDetails?.icon || ""}
                            onChange={(e) => {
                                handleChange(e.target.name, e.target.value)
                            }}
                        >
                            {FeatherIconsNameArray?.map((option, index) => {
                                if (option !== "default") {
                                    const IconComponent = FeatherIconsList[option];
                                    return (
                                        <MenuItem title={option} key={option} value={option} style={{ display: 'flex', justifyContent: 'center' }}>
                                            <IconComponent size="2em" />
                                        </MenuItem>
                                    );
                                }
                                return null;
                            })}
                        </TextField>
                        <div id='randOption' className={Styles.randOption}>
                            <p id='inputLabel' className={Styles.inputLabel}>
                                {t('QualityQuotient.CreateMetric.orderStyle.label')}
                            </p>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name='ordered'
                                        checked={!metricDetails.is_random}
                                        onClick={() => handleChange("is_random", false)}
                                        label={t('QualityQuotient.CreateMetric.orderStyle.order.checkbox')}
                                    />
                                }
                                labelPlacement="start"
                                label={t('QualityQuotient.CreateMetric.orderStyle.order.label')}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name='random'
                                        checked={metricDetails.is_random}
                                        onClick={() => handleChange("is_random", true)}
                                        label={t('QualityQuotient.CreateMetric.orderStyle.random.checkbox')}
                                    />
                                }
                                labelPlacement="start"
                                label={t('QualityQuotient.CreateMetric.orderStyle.random.label')}
                            />
                        </div>
                        <Tooltip arrow placement="right" title={t('QualityQuotient.CreateMetric.attempt.tooltip')}>
                            <p id='inputLabel' className={Styles.inputLabel}>
                                {t('QualityQuotient.CreateMetric.attempt.label')}
                                <FeatherIcon size="0.9em" icon="info" />
                            </p>
                        </Tooltip>
                        <TextField
                            id={`metric-max-attempts`}
                            name="max_attempts"
                            fullWidth
                            type="number"
                            placeholder={t('QualityQuotient.CreateMetric.attempt.placeholder')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                maxLength: 2
                            }}
                            value={metricDetails.max_attempts || ''}
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                        />
                        <div
                            id='formActionButton'
                            className={Styles.formActionButton}
                            style={{
                                justifyContent: isCreateAction ? "flex-end" : "space-between"
                            }}
                        >
                            {!isCreateAction &&
                                <span id="metricStatusBtn" className={Styles.metricStatusBtn}>
                                    <AivagamButton
                                        type="cancel"
                                        id="closeMetric"
                                        buttonText={
                                            <>
                                                <FeatherIcon
                                                    color='black'
                                                    icon='stop-circle'
                                                />
                                                {t('QualityQuotient.CreateMetric.form.button.close.text')}
                                            </>
                                        }
                                        icon
                                        onClick={() => {
                                            postMetricDetails({ updateStatus: "closed" })
                                        }}
                                        tooltipText={metricDetails.status !== "published"
                                            ? t('QualityQuotient.CreateMetric.form.button.close.tooltip.notPublished')
                                            : t('QualityQuotient.CreateMetric.form.button.close.tooltip.published')
                                        }
                                        disabled={metricDetails.status !== "published"}
                                    />
                                    <AivagamButton
                                        type="confirm"
                                        id="publishButton"
                                        buttonText={
                                            <>
                                                <FeatherIcon
                                                    color='white'
                                                    icon='play-circle'
                                                />
                                                {t('QualityQuotient.CreateMetric.form.button.publish.text')}
                                            </>
                                        }
                                        icon
                                        onClick={() => {
                                            postMetricDetails({ updateStatus: "published" })
                                        }}
                                        tooltipText={getPublishTooltipText(metricDetails, assessmentData)}
                                        disabled={
                                            metricDetails.status === "published"
                                            || assessmentData.length === 0
                                            || assessmentData.some(assessment => assessment.questions === null)
                                        }
                                    />
                                </span>
                            }
                            <Tooltip
                                open={showUpdateTooltip}
                                arrow
                                title={t('QualityQuotient.CreateMetric.form.button.save.alertTooltip')}
                                placement="left"
                            >
                                <span>
                                    <AivagamButton
                                        type="confirm"
                                        id="saveForm"
                                        buttonText={
                                            <>
                                                <FeatherIcon
                                                    color='white'
                                                    icon='save'
                                                />
                                                {t('QualityQuotient.CreateMetric.form.button.save.text')}
                                            </>
                                        }
                                        icon
                                        onClick={postMetricDetails}
                                        tooltipText={t('QualityQuotient.CreateMetric.form.button.save.tooltip')}
                                    // disabled={Object.values(metricDetails).some(value => value === '')}
                                    />
                                </span>
                            </Tooltip>
                        </div>
                    </div>

                    {/* Assessments */}
                    {!isCreateAction &&
                        <div id='assessmentsContainer' className={Styles.assessmentsContainer}>
                            <div id='assessTitle' className={Styles.assessTitle}>
                                <p id='formTitle' className={Styles.formTitle}>
                                    {t('QualityQuotient.CreateMetric.assessment.title')}
                                </p>
                                <span id='assessmentBtnContainer' className={Styles.assessmentBtnContainer}>
                                    <AivagamButton
                                        id='saveOrder'
                                        onClick={saveChangedOrder}
                                        icon
                                        buttonText={
                                            <>
                                                <FeatherIcon icon="save" />
                                                {t('QualityQuotient.CreateMetric.assessment.button.saveOrder.text')}
                                            </>
                                        }
                                        tooltipText={
                                            editingOrder
                                                ? t('QualityQuotient.CreateMetric.assessment.button.saveOrder.tooltip.editingOrder')
                                                : t('QualityQuotient.CreateMetric.assessment.button.saveOrder.tooltip.default')
                                        }
                                        type="confirm"
                                        disabled={!editingOrder || metricDetails.status === "published"}
                                    />
                                    <AivagamButton
                                        id='addAssess'
                                        onClick={() => {
                                            if (!showAddAssess) {
                                                setEditAssessment(-1)
                                                setShowAddAssess(true)
                                            }
                                            else {
                                                viewContext.notification.show("Finish Adding to Add Another!", "warning", false)
                                            }
                                        }}
                                        icon
                                        buttonText={
                                            <>
                                                <FeatherIcon icon="plus" />
                                                {t('QualityQuotient.CreateMetric.assessment.button.addAssessText')}
                                            </>
                                        }
                                        tooltipText={
                                            disableAssessmentEdit
                                                ? t('QualityQuotient.CreateMetric.assessment.assesTooltip')
                                                : null
                                        }
                                        type="edit"
                                        disabled={disableAssessmentEdit}
                                    />
                                </span>
                            </div>
                            <div id='assessmentEdits' className={Styles.assessmentEdits}>
                                {assessmentData.length === 0 ? (
                                    <p id="noAssessText" className={Styles.noAssessText}>
                                        {t('QualityQuotient.CreateMetric.assessment.noAssessment')}
                                    </p>
                                ) : (
                                    assessmentData.map((assessment, index) => {
                                        if (index !== editAssessment) {
                                            return (
                                                <Fragment key={assessment.id}>
                                                    <AssessmentCard assessmentDataEntry={assessment} currentIndex={index} />
                                                </Fragment>
                                            );
                                        }
                                        return (
                                            <Fragment key={assessment.id}>
                                                <AddAssessmentJSX currentIndex={index} />
                                            </Fragment>
                                        );
                                    })
                                )}
                                {showAddAssess &&
                                    <AddAssessmentJSX currentIndex={assessmentData.length} />
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
